export default class SetlistLaughDto {
    order: number | null = null;
    setlistLaughId: number = 0;

    constructor(setlistLaughDto?: Partial<SetlistLaughDto>) {
        Object.assign(this, setlistLaughDto);
    };
}